// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AdminLocationsPageQueryVariables = Types.Exact<{
  filter: Types.LocationsFilter;
}>;


export type AdminLocationsPageQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'Location', id: string, name: string, version: number, pathAsCode?: string | null | undefined, path?: string | null | undefined, displayLocationPath: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string }, roomType?: { __typename?: 'RoomType', id: string, name: string } | null | undefined }> };

export type AdminLocationsPage_LocationFragment = { __typename?: 'Location', id: string, name: string, version: number, pathAsCode?: string | null | undefined, path?: string | null | undefined, displayLocationPath: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string }, roomType?: { __typename?: 'RoomType', id: string, name: string } | null | undefined };

export const AdminLocationsPage_LocationFragmentDoc = gql`
    fragment AdminLocationsPage_Location on Location {
  id
  name
  version
  type {
    code
    name
  }
  roomType {
    id
    name
  }
  pathAsCode
  path
  displayLocationPath
}
    `;
export const AdminLocationsPageDocument = gql`
    query AdminLocationsPage($filter: LocationsFilter!) {
  locations(filter: $filter) {
    ...AdminLocationsPage_Location
  }
}
    ${AdminLocationsPage_LocationFragmentDoc}`;

/**
 * __useAdminLocationsPageQuery__
 *
 * To run a query within a React component, call `useAdminLocationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminLocationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminLocationsPageQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAdminLocationsPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AdminLocationsPageQuery, AdminLocationsPageQueryVariables> & ({ variables: AdminLocationsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminLocationsPageQuery, AdminLocationsPageQueryVariables>(AdminLocationsPageDocument, options);
      }
export function useAdminLocationsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminLocationsPageQuery, AdminLocationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminLocationsPageQuery, AdminLocationsPageQueryVariables>(AdminLocationsPageDocument, options);
        }
// @ts-ignore
export function useAdminLocationsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AdminLocationsPageQuery, AdminLocationsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminLocationsPageQuery, AdminLocationsPageQueryVariables>;
export function useAdminLocationsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminLocationsPageQuery, AdminLocationsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AdminLocationsPageQuery | undefined, AdminLocationsPageQueryVariables>;
export function useAdminLocationsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AdminLocationsPageQuery, AdminLocationsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AdminLocationsPageQuery, AdminLocationsPageQueryVariables>(AdminLocationsPageDocument, options);
        }
export type AdminLocationsPageQueryHookResult = ReturnType<typeof useAdminLocationsPageQuery>;
export type AdminLocationsPageLazyQueryHookResult = ReturnType<typeof useAdminLocationsPageLazyQuery>;
export type AdminLocationsPageSuspenseQueryHookResult = ReturnType<typeof useAdminLocationsPageSuspenseQuery>;
export type AdminLocationsPageQueryResult = Apollo.QueryResult<AdminLocationsPageQuery, AdminLocationsPageQueryVariables>;